@for (descriptor of group.members; track descriptor.name) {
  <div
    class="wp-attribute-group--attribute attributes-key-value"
    [ngClass]="{'wp-attribute-group--attribute_span-all': descriptor.spanAll }"
    >
    @if (!shouldHideField(descriptor)) {
      @if (!descriptor.multiple && descriptor.field) {
        <div
          class="wp-attribute-group--attribute-key attributes-key-value--key"
          >
          <wp-replacement-label [fieldName]="descriptor.name">
            {{ descriptor.label }}
            @if (descriptor.field!.required && descriptor.field!.writable) {
              <span
                class="required"
              > *</span>
            }
          </wp-replacement-label>
          <attribute-help-text [attribute]="descriptor.name" [attributeScope]="'WorkPackage'" />
        </div>
      }
      @if (!descriptor.multiple && descriptor.field) {
        <div
          class="wp-attribute-group--attribute-value-container attributes-key-value--value-container"
          >
          <op-editable-attribute-field [ngClass]="{'wp-edit-formattable-field': descriptor.field!.isFormattable }"
            [resource]="workPackage"
            [isDropTarget]="descriptor.field!.isFormattable"
            [fieldName]="descriptor.field!.name"
           />
        </div>
      }
    }
  </div>
}
